import { render } from "./FaceIdSvg.vue?vue&type=template&id=1d7eb803"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__